<template>
  <div class="dispute-orders">
    <base-status-orders
      :status="'DISPUTE'"
      :title="'争议订单'"
      :show-actions="true">
      <template #actions="{ row }">
        <el-button 
          type="primary" 
          size="mini" 
          @click="handleViewDispute(row)">查看争议</el-button>
        <el-button 
          type="success" 
          size="mini" 
          @click="handleUploadRetest(row)">上传复测结果</el-button>
      </template>
    </base-status-orders>

    <!-- 争议详情对话框 -->
    <el-dialog
      title="争议详情"
      :visible.sync="disputeDialogVisible"
      width="600px">
      <div class="dispute-info">
        <div class="info-item">
          <span class="label">争议原因：</span>
          <span class="value">{{ currentDispute.reason }}</span>
        </div>
        <div class="info-item">
          <span class="label">提交时间：</span>
          <span class="value">{{ currentDispute.createTime }}</span>
        </div>
        <div class="info-item" v-if="currentDispute.comment">
          <span class="label">备注信息：</span>
          <span class="value">{{ currentDispute.comment }}</span>
        </div>
      </div>
      
      <!-- 争议附件列表 -->
      <div v-if="currentDispute.disputeFiles && currentDispute.disputeFiles.length > 0" class="dispute-files">
        <h3 class="file-list-title">争议附件</h3>
        <el-table
          :data="currentDispute.disputeFiles"
          style="width: 100%"
          border>
          <el-table-column
            prop="name"
            label="文件名"
            min-width="300">
          </el-table-column>
          <el-table-column
            prop="size"
            label="大小"
            width="150">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.size) }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            align="center">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                @click="handlePreview(scope.row)">预览</el-button>
              <el-button 
                type="text" 
                size="small" 
                @click="handleDownload(scope.row)"
                style="margin-left: 10px;">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="disputeDialogVisible = false">关闭</el-button>
        <el-button 
          type="primary" 
          @click="handleUploadRetestFromDialog">上传复测结果</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaseStatusOrders from './BaseStatusOrders.vue'
import adminApi from '@/api/adminApi'

export default {
  name: 'DisputeOrders',
  components: {
    BaseStatusOrders
  },
  data() {
    return {
      disputeDialogVisible: false,
      currentDispute: {
        reason: '',
        createTime: '',
        comment: '',
        disputeFiles: [],
        orderId: null
      }
    }
  },
  methods: {
    handleViewDispute(row) {
      this.currentDispute = {
        reason: row.disputeRemark || '',
        createTime: row.disputeCreateTime || '',
        comment: row.disputeComment || '',
        disputeFiles: row.orderDisputeFileList || [],
        orderId: row.id
      }
      this.disputeDialogVisible = true
    },
    handleUploadRetest(row) {
      // 跳转到订单详情页并打开上传复测结果区域
      this.$router.push({
        path: `/admin/orders/management/${row.id}`,
        query: { step: 'UPLOAD_RETEST', action: 'upload_retest' }
      })
    },
    handleUploadRetestFromDialog() {
      if (this.currentDispute.orderId) {
        this.disputeDialogVisible = false
        this.$router.push({
          path: `/admin/orders/management/${this.currentDispute.orderId}`,
          query: { step: 'UPLOAD_RETEST', action: 'upload_retest' }
        })
      } else {
        this.$message.error('获取订单ID失败，无法跳转')
      }
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return size.toFixed(2) + ' ' + units[index]
    }
  }
}
</script>

<style scoped>
.dispute-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.dispute-form {
  width: 100%;
}

.form-title {
  margin-bottom: 30px;
  color: #303133;
  font-size: 20px;
  text-align: center;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 上传区域样式 */
.upload-demo {
  width: 100%;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
}

/* 争议信息样式 */
.dispute-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #fdf6ec;
  border-radius: 4px;
  color: #e6a23c;
}

.info-item {
  margin-bottom: 10px;
}

.info-item .label {
  font-weight: bold;
  margin-right: 10px;
}

.dispute-files {
  margin-top: 20px;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
}

.file-list-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
}
</style> 